import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Button,
  Dialog, DialogTitle, DialogContent, DialogActions,
  IconButton, Tooltip,
  Grid
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import axios from "axios";
import Header from "../Header";
import { Chip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const getStatusChip = (status) => {
  let color = "default";

  switch (status) {
    case "Done":
      color = "success";
      break;
    case "In Progress":
      color = "warning";
      break;
    case "Pending":
      color = "error";
      break;
    default:
      color = "default";
  }

  return (
    <Chip
      label={status || "Unknown"}
      color={color}
      size="small"
      variant="outlined"
    />
  );
};
  const url = process.env.REACT_APP_SERVER_URL;

const ActivityManagement = () => {
  const [tasks, setTasks] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [assignedTo, setAssignedTo] = useState("All");
  const [status, setStatus] = useState("All");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [uniqueAssignees, setUniqueAssignees] = useState([]);
  const [editRow, setEditRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const handleEditClick = (row) => {
    setEditRow(row);
    setOpenDialog(true);
    };

    const handleDialogClose = () => {
    setOpenDialog(false);
    // setEditRow(null);
    };


  useEffect(() => {
    fetchTasks();
    getAllUsers();
  }, []);

  const fetchTasks = async () => {
    try {
      const response = await axios.get(`${url}/tasklogs`);
      if (response?.data) {
        const data = response.data;
        console.log(data);
        setTasks(data);
        setFiltered(data);

        // Extract unique assignee names for dropdown
        // const names = [...new Set(data.map((t) => t.assigned_user_name).filter(Boolean))];
        // setUniqueAssignees(names);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const applyFilters = () => {
    let filteredTasks = [...tasks];

    if (assignedTo && assignedTo!=="All") {
      filteredTasks = filteredTasks.filter((t) => t.assigned_user_name === assignedTo);
    }

    if (status && status!=="All") {
      filteredTasks = filteredTasks.filter((t) => t.status === status);
    }

    if (fromDate) {
      filteredTasks = filteredTasks.filter(
        (t) => dayjs(t.expected_date).isAfter(dayjs(fromDate).subtract(1, "day"))
      );
    }

    if (toDate) {
      filteredTasks = filteredTasks.filter(
        (t) => dayjs(t.expected_date).isBefore(dayjs(toDate).add(1, "day"))
      );
    }

    setFiltered(filteredTasks);
  };
  const handleSaveEdit = async (updatedData) => {
  try {
    const response = await axios.patch(`/api/taskLogs/${updatedData.id}`, updatedData);
    if (response && response.data) {
      // Optional: update the row in local state
      const updatedList = tasks.map((task) =>
        task.id === updatedData.id ? response.data : task
      );
      setTasks(updatedList);
      setFiltered(updatedList); // apply filters again if needed
    }
    handleDialogClose();
    setEditRow(null);
  } catch (error) {
    console.error("Failed to save edit:", error);
  }
};
const getAllUsers = async() =>{
        try{
            const response  = await axios.get(`${url}/users`);
            if(response && response.data){
                setUniqueAssignees(response.data);
            }
    
        }
        catch(error){
            console.log(error);
        }
    }


  const columns = [
    { field: "title", headerName: "Title", flex: 1 },
    { field: "assigned_user_name", headerName: "Assigned To", flex: 1 },
    { field: "status", headerName: "Status", flex: 1,
        renderCell: (params) => getStatusChip(params.value)
     },
    {
  field: "expected_date",
  headerName: "Expected Date",
  flex: 1,
  renderCell: (params) =>
    params.value
      ? dayjs(params.value).format("MMM D, YYYY")
      : <span style={{ color: '#888' }}>-</span>
},
{
  field: "end_date",
  headerName: "Completed Date",
  flex: 1,
  renderCell: (params) =>
    params.value
      ? dayjs(params.value).format("MMM D, YYYY")
      : <span style={{ color: '#888' }}>-</span>
},

    { field: "description", headerName: "Description", flex: 2 },
    {
    field: "actions",
    headerName: "Actions",
    width: 80,
    sortable: false,
    renderCell: (params) => (
       
        
            <EditIcon onClick={() => handleEditClick(params.row)}/>
    
    ),
    }
    
  ];

  return (
    <>
    <Header/>
    <Box sx={{ p: 4 }}>
      <h2 style={{ marginBottom: 16 }}>Activity Dashboard</h2>

      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" mb={3}>
        <FormControl sx={{ minWidth: 180 }} size="small">
          <InputLabel>Assigned To</InputLabel>
          <Select
            value={assignedTo}
            onChange={(e) => setAssignedTo(e.target.value)}
            label="Assigned To"
          >
            <MenuItem value="All">All</MenuItem>
            {uniqueAssignees.map((row) => (
              <MenuItem key={row.id} value={row.name}>
                {row.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 180 }} size="small">
          <InputLabel>Status</InputLabel>
          <Select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            label="Status"
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Pending">Not Started</MenuItem>
            <MenuItem value="In Progress">In Progress</MenuItem>
            <MenuItem value="Done">Completed</MenuItem>
          </Select>
        </FormControl>

        <TextField
          type="date"
          label="From"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <TextField
          type="date"
          label="To"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />

        <Button variant="contained" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Stack>

      <DataGrid
        rows={filtered}
        columns={columns}
        getRowId={(row) => row.id}
        autoHeight
        pageSize={10}
        rowsPerPageOptions={[10, 20]}
        disableSelectionOnClick
        sx={{
          "& .MuiDataGrid-cell": { py: 0.5 },
          backgroundColor: "#fff",
          borderRadius: 2,
        }}
      />
    </Box>
    { openDialog && <EditTaskDialog
        open={openDialog}
        handleClose={handleDialogClose}
        rowData={editRow}
        handleSave={handleSaveEdit}
        /> }
    </>
  );
};



const statusOptions = ["Pending", "In Progress", "Done"];

const EditTaskDialog = ({ open, handleClose, rowData, handleSave }) => {
  const [formData, setFormData] = useState(rowData || {});
  const [assignedUserList, setAssignedUserList] = useState([])

  useEffect(() => {
    setFormData(rowData || {});
    getAllUsers();
  }, [rowData]);
    const getAllUsers = async() =>{
        try{
            const response  = await axios.get(`${url}/users`);
            if(response && response.data){
                setAssignedUserList(response.data);
            }
    
        }
        catch(error){
            console.log(error);
        }
    }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Edit Task</DialogTitle>
      <DialogContent>
        <br></br>
  <Grid container spacing={2}>
    {/* Row 1: Title and Assigned To */}
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        name="title"
        label="Title"
        value={formData.title || ""}
        onChange={handleChange}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth variant="outlined">
        <InputLabel shrink>Assigned To</InputLabel>
        <Select
          name="assigned_to"
          value={formData.assigned_to || ""}
          onChange={handleChange}
          label="Assigned To"
        >
          {assignedUserList.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* Row 2: Description */}
    <Grid item xs={12}>
      <TextField
        fullWidth
        multiline
        minRows={3}
        name="description"
        label="Description"
        variant="outlined"
        value={formData.description || ""}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>

    {/* Row 3: Status and Completed Date */}
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth variant="outlined">
        <InputLabel shrink>Status</InputLabel>
        <Select
          name="status"
          value={formData.status || ""}
          onChange={handleChange}
          label="Status"
        >
          {statusOptions.map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        name="end_date"
        label="Completed Date"
        type="date"
        variant="outlined"
        value={formData.end_date || ""}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>
  </Grid>
</DialogContent>



      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={() => handleSave(formData)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};


export default ActivityManagement;
